export default {
    UNKNOW_ERROR_FETCHING_PROFILE: 'unknownErrorGettingAccountProfile',
};
